import { Box, Container, Grid, Typography } from '@mui/material'
import { COLOR_PRIMARY, DARK_800, SECTION_DARK } from '../theme'

export interface ProblemBoxItem {
    problem: string
    solution: string
}

interface ProblemBoxProps {
    title?: string
    quote: string
    items: ProblemBoxItem[]
    color?: string
}

export function ProblemBox({ quote, items, title, color = COLOR_PRIMARY }: ProblemBoxProps) {
    return (
        <Box sx={{ ...SECTION_DARK }}>
            <Container maxWidth="lg">
                {title && <Typography variant="h2" sx={{ color: 'white', textAlign: 'center', mb: 2 }}>
                    {title}
                </Typography>}
                <Typography variant="h4" sx={{ color: 'rgba(255,255,255,0.7)', textAlign: 'center', fontWeight: 400, mb: 6, fontStyle: 'italic', fontSize: { xs: '16px', md: '18px' } }}>
                    "{quote}"
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                    {items.map((item, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box sx={{
                                background: 'rgba(255,255,255,0.04)',
                                border: '1px solid rgba(255,255,255,0.08)',
                                borderRadius: 2,
                                p: 3,
                                height: '100%',
                            }}>
                                <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', lineHeight: 1.6, mb: 1 }}>
                                    {item.problem}
                                </Typography>
                                <Typography sx={{ color: color, fontWeight: 700, fontSize: '15px' }}>
                                    {item.solution}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}
